<template>
    <div class="dates">
        <div v-if="window && window.startDate">{{ formatDate(window.startDate) }}</div>
        <div v-else>{{ formatDate(forecast.startDate) }}</div>
        <div id="svg"><CalendarIcon :color="iconColor" /></div>
        <div v-if="window && window.endDate">{{ formatDate(window.endDate) }}</div>
        <div v-else>{{ formatDate(forecast.endDate) }}</div>
    </div>
</template>
<script>
import CalendarIcon from "@/components/forecasts/elements/icons/CalendarIcon";
import { getStatusColor } from "@/components/forecasts/utils/utilis";

export default {
    components: { CalendarIcon },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        window: {
            type: Object,
            required: true
        }
    },
    computed: {
        iconColor() {
            return getStatusColor(this.forecast.deleted ? "DELETE" : this.forecast.status);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../css/forecasts.scss";
.dates {
    width: 125px;
    #svg {
        margin: 5px auto 15px auto;
        width: 40px;
        height: 40px;
    }
    div {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// DateInfo.vue?6d8680fc